import type { PreviewState } from '../lib/liveTranscription.js';
import { useAgentCopy } from '../lib/agentCopy.js';
export function LiveTranscript({preview}:{preview:PreviewState}){
  const c=useAgentCopy();
  if(preview.status==='idle'&&!preview.text)return null;
  return <div className="mx-auto w-full max-w-md shrink-0 rounded-2xl border border-border/60 bg-background/80 px-4 py-3 text-start">
    <p className="text-xs text-muted-foreground">{c('liveTranscript')}</p>
    {preview.text&&<p dir="auto" className="max-h-[min(15dvh,96px)] overflow-y-auto break-words text-sm leading-6 mt-1" aria-live="off">{preview.text}</p>}
    <p role="status" className="mt-1 text-[11px] text-muted-foreground">{c(preview.status==='unavailable'?'liveFallback':'liveDraft')}</p>
  </div>;
}
